<div class="container mt-4">
  <lib-ngf-attachments-list [documents]="realDocs"></lib-ngf-attachments-list>
</div>
